export type Destination = {
  name: string;
  km: number;
  country: 'AT' | 'DE' | 'CZ' | 'IT' | 'SI';
  flag: string;
  popular?: boolean;
};

export const countryLabels: Record<string, string> = {
  AT: '🇦🇹 Österreich',
  DE: '🇩🇪 Deutschland',
  CZ: '🇨🇿 Tschechien',
  IT: '🇮🇹 Italien',
  SI: '🇸🇮 Slowenien',
};

export const destinations: Destination[] = [
  // AUSTRIA
  { name: 'Abtenau', km: 47, country: 'AT', flag: '🇦🇹' },
  { name: 'Adnet', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Altenmarkt im Pongau', km: 67, country: 'AT', flag: '🇦🇹' },
  { name: 'Anif', km: 7, country: 'AT', flag: '🇦🇹' },
  { name: 'Annaberg-Lungötz', km: 73, country: 'AT', flag: '🇦🇹' },
  { name: 'Bad Gastein', km: 94, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Bad Hofgastein', km: 87, country: 'AT', flag: '🇦🇹' },
  { name: 'Bad Ischl', km: 54, country: 'AT', flag: '🇦🇹' },
  { name: 'Bad Vigaun', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Berndorf bei Salzburg', km: 27, country: 'AT', flag: '🇦🇹' },
  { name: 'Bischofshofen', km: 50, country: 'AT', flag: '🇦🇹' },
  { name: 'Bramberg am Wildkogel', km: 129, country: 'AT', flag: '🇦🇹' },
  { name: 'Bruck an der Großglocknerstraße', km: 90, country: 'AT', flag: '🇦🇹' },
  { name: 'Bürmoos', km: 29, country: 'AT', flag: '🇦🇹' },
  { name: 'Dienten am Hochkönig', km: 72, country: 'AT', flag: '🇦🇹' },
  { name: 'Dorfgastein', km: 78, country: 'AT', flag: '🇦🇹' },
  { name: 'Ebensee', km: 71, country: 'AT', flag: '🇦🇹' },
  { name: 'Eben im Pongau', km: 62, country: 'AT', flag: '🇦🇹' },
  { name: 'Elixhausen', km: 11, country: 'AT', flag: '🇦🇹' },
  { name: 'Ellmau', km: 87, country: 'AT', flag: '🇦🇹' },
  { name: 'Eugendorf', km: 12, country: 'AT', flag: '🇦🇹' },
  { name: 'Faistenau', km: 23, country: 'AT', flag: '🇦🇹' },
  { name: 'Filzmoos', km: 72, country: 'AT', flag: '🇦🇹' },
  { name: 'Flachau', km: 70, country: 'AT', flag: '🇦🇹' },
  { name: 'Forstau', km: 77, country: 'AT', flag: '🇦🇹' },
  { name: 'Fuschl am See', km: 24, country: 'AT', flag: '🇦🇹' },
  { name: 'Goldegg', km: 69, country: 'AT', flag: '🇦🇹' },
  { name: 'Golling an der Salzach', km: 28, country: 'AT', flag: '🇦🇹' },
  { name: 'Grödig', km: 8, country: 'AT', flag: '🇦🇹' },
  { name: 'Großarl', km: 75, country: 'AT', flag: '🇦🇹' },
  { name: 'Hallein', km: 18, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Hallstatt', km: 76, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Henndorf am Wallersee', km: 17, country: 'AT', flag: '🇦🇹' },
  { name: 'Hintersee', km: 32, country: 'AT', flag: '🇦🇹' },
  { name: 'Hof bei Salzburg', km: 16, country: 'AT', flag: '🇦🇹' },
  { name: 'Hollersbach im Pinzgau', km: 124, country: 'AT', flag: '🇦🇹' },
  { name: 'Hüttau', km: 56, country: 'AT', flag: '🇦🇹' },
  { name: 'Hüttschlag', km: 82, country: 'AT', flag: '🇦🇹' },
  { name: 'Innsbruck', km: 193, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Kaprun', km: 100, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Koppl', km: 13, country: 'AT', flag: '🇦🇹' },
  { name: 'Köstendorf', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Krimml', km: 145, country: 'AT', flag: '🇦🇹' },
  { name: 'Kuchl', km: 24, country: 'AT', flag: '🇦🇹' },
  { name: 'Lamprechtshausen', km: 26, country: 'AT', flag: '🇦🇹' },
  { name: 'Linz', km: 136, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Lofer', km: 54, country: 'AT', flag: '🇦🇹' },
  { name: 'Maria Alm', km: 85, country: 'AT', flag: '🇦🇹' },
  { name: 'Mariapfarr', km: 123, country: 'AT', flag: '🇦🇹' },
  { name: 'Mauterndorf', km: 117, country: 'AT', flag: '🇦🇹' },
  { name: 'Mayrhofen', km: 182, country: 'AT', flag: '🇦🇹' },
  { name: 'Mittersill', km: 119, country: 'AT', flag: '🇦🇹' },
  { name: 'Mondsee', km: 30, country: 'AT', flag: '🇦🇹' },
  { name: 'Muhr', km: 117, country: 'AT', flag: '🇦🇹' },
  { name: 'Neukirchen am Großvenediger', km: 136, country: 'AT', flag: '🇦🇹' },
  { name: 'Niedernsill', km: 106, country: 'AT', flag: '🇦🇹' },
  { name: 'Nußdorf am Haunsberg', km: 23, country: 'AT', flag: '🇦🇹' },
  { name: 'Oberalm', km: 15, country: 'AT', flag: '🇦🇹' },
  { name: 'Oberndorf bei Salzburg', km: 21, country: 'AT', flag: '🇦🇹' },
  { name: 'Obertrum am See', km: 19, country: 'AT', flag: '🇦🇹' },
  { name: 'Obertauern', km: 89, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Piesendorf', km: 100, country: 'AT', flag: '🇦🇹' },
  { name: 'Plainfeld', km: 14, country: 'AT', flag: '🇦🇹' },
  { name: 'Puch bei Hallein', km: 13, country: 'AT', flag: '🇦🇹' },
  { name: 'Radstadt', km: 69, country: 'AT', flag: '🇦🇹' },
  { name: 'Rauris', km: 87, country: 'AT', flag: '🇦🇹' },
  { name: 'Rußbach am Paß Gschütt', km: 56, country: 'AT', flag: '🇦🇹' },
  { name: 'Saalbach-Hinterglemm', km: 115, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Saalfelden', km: 77, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Gilgen', km: 32, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Johann im Pongau', km: 59, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Koloman', km: 33, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Martin bei Lofer', km: 56, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Michael im Lungau', km: 107, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Veit im Pongau', km: 64, country: 'AT', flag: '🇦🇹' },
  { name: 'Salzburg Airport (SZG)', km: 8, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Salzburg Hauptbahnhof', km: 4, country: 'AT', flag: '🇦🇹' },
  { name: 'Salzburg Altstadt', km: 0, country: 'AT', flag: '🇦🇹' },
  { name: 'Schladming', km: 88, country: 'AT', flag: '🇦🇹' },
  { name: 'Seeham', km: 24, country: 'AT', flag: '🇦🇹' },
  { name: 'Seekirchen am Wallersee', km: 15, country: 'AT', flag: '🇦🇹' },
  { name: 'Strobl', km: 43, country: 'AT', flag: '🇦🇹' },
  { name: 'St. Wolfgang im Salzkammergut', km: 49, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Tamsweg', km: 122, country: 'AT', flag: '🇦🇹' },
  { name: 'Taxenbach', km: 80, country: 'AT', flag: '🇦🇹' },
  { name: 'Thalgau', km: 22, country: 'AT', flag: '🇦🇹' },
  { name: 'Unken', km: 45, country: 'AT', flag: '🇦🇹' },
  { name: 'Uttendorf', km: 112, country: 'AT', flag: '🇦🇹' },
  { name: 'Vienna (Wien)', km: 298, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Vigaun', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Vöcklabruck', km: 70, country: 'AT', flag: '🇦🇹' },
  { name: 'Wagrain', km: 67, country: 'AT', flag: '🇦🇹' },
  { name: 'Wald im Pinzgau', km: 140, country: 'AT', flag: '🇦🇹' },
  { name: 'Wals-Siezenheim', km: 18, country: 'AT', flag: '🇦🇹' },
  { name: 'Werfen', km: 43, country: 'AT', flag: '🇦🇹' },
  { name: 'Werfenweng', km: 50, country: 'AT', flag: '🇦🇹' },
  { name: 'Wolfgangsee', km: 38, country: 'AT', flag: '🇦🇹' },
  { name: 'Zell am See', km: 97, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Zell am Moos', km: 35, country: 'AT', flag: '🇦🇹' },

  // GERMANY
  { name: 'Ainring', km: 15, country: 'DE', flag: '🇩🇪' },
  { name: 'Augsburg', km: 229, country: 'DE', flag: '🇩🇪' },
  { name: 'Bad Reichenhall', km: 26, country: 'DE', flag: '🇩🇪' },
  { name: 'Bayerisch Gmain', km: 28, country: 'DE', flag: '🇩🇪' },
  { name: 'Berchtesgaden', km: 23, country: 'DE', flag: '🇩🇪', popular: true },
  { name: 'Bischofswiesen', km: 27, country: 'DE', flag: '🇩🇪' },
  { name: 'Chiemsee', km: 71, country: 'DE', flag: '🇩🇪' },
  { name: "Eagle's Nest (Kehlsteinhaus)", km: 35, country: 'DE', flag: '🇩🇪', popular: true },
  { name: 'Freilassing', km: 9, country: 'DE', flag: '🇩🇪' },
  { name: 'Garmisch-Partenkirchen', km: 187, country: 'DE', flag: '🇩🇪' },
  { name: 'Hintersee (DE)', km: 924, country: 'DE', flag: '🇩🇪' },
  { name: 'Inzell', km: 52, country: 'DE', flag: '🇩🇪' },
  { name: 'Königssee', km: 27, country: 'DE', flag: '🇩🇪', popular: true },
  { name: 'Laufen', km: 21, country: 'DE', flag: '🇩🇪' },
  { name: 'München (Munich)', km: 147, country: 'DE', flag: '🇩🇪', popular: true },
  { name: 'Passau', km: 116, country: 'DE', flag: '🇩🇪' },
  { name: 'Prien am Chiemsee', km: 71, country: 'DE', flag: '🇩🇪' },
  { name: 'Ramsau (DE)', km: 31, country: 'DE', flag: '🇩🇪' },
  { name: 'Reit im Winkl', km: 75, country: 'DE', flag: '🇩🇪' },
  { name: 'Rosenheim', km: 91, country: 'DE', flag: '🇩🇪' },
  { name: 'Ruhpolding', km: 52, country: 'DE', flag: '🇩🇪' },
  { name: 'Schönau am Königssee', km: 27, country: 'DE', flag: '🇩🇪' },
  { name: 'Tegernsee', km: 123, country: 'DE', flag: '🇩🇪' },
  { name: 'Teisendorf', km: 34, country: 'DE', flag: '🇩🇪' },
  { name: 'Tittmoning', km: 40, country: 'DE', flag: '🇩🇪' },
  { name: 'Traunstein', km: 49, country: 'DE', flag: '🇩🇪' },
  { name: 'Waging am See', km: 46, country: 'DE', flag: '🇩🇪' },
  { name: 'Zugspitze', km: 193, country: 'DE', flag: '🇩🇪' },

  // CZECH REPUBLIC
  { name: 'Český Krumlov', km: 220, country: 'CZ', flag: '🇨🇿', popular: true },
  { name: 'České Budějovice', km: 233, country: 'CZ', flag: '🇨🇿' },
  { name: 'Karlovy Vary', km: 448, country: 'CZ', flag: '🇨🇿' },
  { name: 'Praha (Prague)', km: 376, country: 'CZ', flag: '🇨🇿' },

  // ITALY
  { name: 'Bozen (Bolzano)', km: 305, country: 'IT', flag: '🇮🇹' },
  { name: 'Brixen', km: 266, country: 'IT', flag: '🇮🇹' },
  { name: 'Lago di Braies', km: 245, country: 'IT', flag: '🇮🇹' },
  { name: 'Meran', km: 336, country: 'IT', flag: '🇮🇹' },
  { name: 'Sterzing', km: 236, country: 'IT', flag: '🇮🇹' },

  // SLOVENIA
  { name: 'Bled', km: 229, country: 'SI', flag: '🇸🇮' },
  { name: 'Ljubljana', km: 276, country: 'SI', flag: '🇸🇮' },
];
